import http from './http'
import Resource from './resource'

const path = 'admin/countries'

class Countries extends Resource {
  constructor(_http) {
    super(path, _http)
  }

  select(opt = {}) {
    return this.http.get(`api/${path}/select/list`, opt)
  }
}

const CountriesRequest = new Countries(http)

export default CountriesRequest
